import { render, staticRenderFns } from "./CmgOrderConfirmationOrderSummary.vue?vue&type=template&id=bcc75908&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-order-summary.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-order-summary.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationOrderSummary.vue?vue&type=style&index=0&id=bcc75908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc75908",
  null
  
)

export default component.exports